<div class="modal-header card-header bg-dark">
    <div class="col-6 col-md-8">
        <span class="text-blue text-125">Configuración Whatsapp</span>
    </div>
    <div class="col-6 col-md-4">
        <button class="btn btn-primary" type="button">
            <i class="fas fa-save red2 text-110 mr-1"></i>
        </button>&nbsp;
        <button class="btn btn-danger" type="button" (click)="cerrarComponente()">
          <i class="fa fa-times red2 text-110 mr-1"></i>
        </button>
    </div>
</div>
<div class="modal-body card-body">
    <div class="dashboard-container">
  <h2>Control de WhatsApp - Empresa {{ usuario.id_empresa }}</h2>

  <!-- Badge de Estado Dinámico -->
  <div class="badge" [ngClass]="status().status">
    Estado actual: {{ status().status | uppercase }}
  </div>

  <!-- Botones de Acción -->
  <div class="actions">
    @if (status().status === 'desconectado') {
      <button class="btn-primary" (click)="vincularWhatsApp()">Vincular WhatsApp</button>
    }
    
    @if (status().status === 'conectado' || status().status === 'escaneando') {
      <button class="btn-danger" (click)="abrirPopupConfirmacionEliminacion()">Desvincular Cuenta</button>
    }
  </div>

  <!-- Contenedor del Código QR (Solo si está escaneando y hay un QR activo) -->
  @if (status().status === 'escaneando' && status().qr) {
    <div class="qr-box">
      <p>Escanea este código QR desde tu app móvil de WhatsApp:</p>
      
      <!-- Renderizado nativo con angularx-qrcode -->
      <qrcode 
        [qrdata]="status().qr!" 
        [width]="256" 
        [errorCorrectionLevel]="'M'">
      </qrcode>
    </div>
  }

  @if (status().status === 'conectado') {
    <div class="success-alert">
      🎉 ¡Tu WhatsApp está enlazado correctamente y listo para operar!
    </div>
  }

  <!-- Bandeja de Entrada en Tiempo Real -->
  <h3>Historial de Mensajes Recibidos (En Vivo)</h3>
  <div class="chat-history">
    @for (msg of mensajes(); track msg.timestamp) {
      <div class="message-card">
        <strong>{{ msg.name }}</strong> <small>({{ msg.sender.split('@')[0] }})</small>
        <p>{{ msg.text }}</p>
      </div>
    } @empty {
      <p class="no-messages">No hay mensajes entrantes capturados en esta sesión todavía.</p>
    }
  </div>
</div>
</div>
